<template>
  <div id="app-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App' 
}
</script>
<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 防止整个页面滚动 */
}
.nav-link {
  margin: 0 10px;
  color: #42b983;
  text-decoration: none;
}
.nav-link.active {
  font-weight: bold;
  color: #2c3e50;
}
</style>
